export default "__VITE_ASSET__Dw3WR57j__"